module.exports = __webpack_public_path__ + "media/images/right-arrow-button-white-9f05a9bc3018d97465f46726a1d25839.svg";